module.exports = __webpack_public_path__ + "img/border_LeftArrow2.7233c092.svg";